import React from 'react';
import XRayHero from '../XRayHero.js'; // Keep using the component we made!

// --- ASSET IMPORTS (Replace these later!) ---
import bg from '../../img/3xr_bg.png';
import charsClothed from '../../img/3xr_clothed.png';
import charsSecret from '../../img/3xr_secret.png';
import angelImg from '../../img/celia.png'
import succubusImg from '../../img/akala.png'
import gameLogoHor from '../../img/xray_logo.png'
import gameLogoImg from '../../img/xray_logo_vert.png'

const styles = {
  page: {
    backgroundColor: 'transparent', // Let the App.js dark navy background shine through
    color: '#f8fafc', // Off-white Text
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    minHeight: '100vh',
    overflowX: 'hidden',
  },
  // HERO WRAPPER
  heroSection: {
    width: '100%',
    height: '90vh',
    position: 'relative',
    borderBottom: '5px solid #ff007f', // Pop of Pink at bottom of hero
  },
  // CONTENT CONTAINER
  content: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '60px 20px',
    backgroundColor: '#111c3a', // Dark Navy card effect
    marginTop: '-50px', // Overlap the hero slightly
    borderRadius: '12px',
    position: 'relative',
    boxShadow: '0 15px 50px rgba(0,0,0,0.5)', // Deep, dark shadow
    zIndex: 10,
    border: '1px solid #1c2b4d', // Subtle inner border to pop it off the background
  },
  flankingChar: {
    position: 'absolute',
    bottom: '0', 
    height: '700px', 
    width: 'auto',
    zIndex: -1, 
    pointerEvents: 'none', 
  },
  angelStyle: {
    left: '-210px', 
  },
  succubusStyle: {
    right: '-210px', 
    transform: 'scaleX(-1)',
  },
  title: {
    fontSize: '3.5rem',
    fontWeight: '900',
    color: '#ffffff', // Pure white so it commands attention
    textAlign: 'center',
    marginBottom: '10px',
    letterSpacing: '-1px',
    textTransform: 'uppercase',
  },
  highlightGreen: {
    color: '#00cc00', // Toxic Green
  },
  subtitle: {
    fontSize: '1.4rem',
    color: '#94a3b8', // Slate grey/blue
    textAlign: 'center',
    marginBottom: '50px',
    fontWeight: '300',
  },
  badgeContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '40px',
    flexWrap: 'wrap',
  },
  badgePrimary: {
    backgroundColor: '#ff007f', // Hot Pink
    color: '#fff',
    padding: '6px 16px',
    borderRadius: '20px', 
    fontSize: '0.85rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    boxShadow: '0 4px 10px rgba(255, 0, 127, 0.3)', // Added a pink glow to the primary badge
  },
  badgeSecondary: {
    backgroundColor: 'rgba(255, 0, 127, 0.1)', // Translucent pink instead of solid light grey
    color: '#ff007f', 
    border: '1px solid #ff007f',
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '0.85rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  // FEATURE GRID
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '40px',
    marginBottom: '60px',
  },
  featureCard: {
    padding: '30px',
    backgroundColor: '#162447', // Slightly lighter navy than the main card
    borderRadius: '8px',
    borderLeft: '4px solid #ff007f', // Pink accent stays
    boxShadow: '0 5px 15px rgba(0,0,0,0.2)', // Soft dark shadow
  },
  featureTitle: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#f8fafc', // Off-white
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  text: {
    color: '#cbd5e1', // Light slate text
    lineHeight: '1.6',
  },
  // BUTTONS
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '40px',
    marginBottom: '20px',
  },
  primaryButton: {
    padding: '18px 50px',
    backgroundColor: '#ff007f', // Hot Pink
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    fontSize: '1.2rem',
    borderRadius: '50px',
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 5px 15px rgba(255, 0, 127, 0.4)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  secondaryButton: {
    padding: '18px 50px',
    backgroundColor: 'transparent', // Transparent background
    color: '#f8fafc', // White text
    fontWeight: 'bold',
    border: '2px solid #2a3b61', // Dark blue border instead of light grey
    fontSize: '1.2rem',
    borderRadius: '50px',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background 0.2s, border-color 0.2s',
  },
  // --- LOGO OVERLAY ---
  logoContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center', 
    justifyContent: 'center', 
    pointerEvents: 'none', 
    zIndex: 5, 
  },
  logoImage: {
    maxWidth: '350px', 
    width: '70%', 
    height: 'auto',
    filter: 'drop-shadow(0 0 15px rgba(255, 0, 127, 0.6))', // Pumped the pink glow up just a tiny bit for the dark theme
  },
};

export default function XRPage() {
  return (
    <div style={styles.page}>
      
      {/* --- HERO SECTION --- */}
      <div style={styles.heroSection}>
        <XRayHero 
          bgImage={bg}
          clothedImage={charsClothed}
          secretImage={charsSecret}
          logoImage={gameLogoImg}
        />
      </div>

      {/* --- MAIN CONTENT CARD --- */}
      <div style={styles.content}>
        
        {/* --- FLANKING CHARACTERS (ANGEL/DEVIL) --- */}
        {/* They are placed here so they position relative to this content box */}
        <img 
            src={angelImg} 
            style={{...styles.flankingChar, ...styles.angelStyle}} 
            alt="Good Path" 
        />
        <img 
            src={succubusImg} 
            style={{...styles.flankingChar, ...styles.succubusStyle}} 
            alt="Evil Path" 
        />

        {/* LOGO TITLE */}
        <h1 style={styles.title}>
          <img src={gameLogoHor} style={{ maxWidth: '500px' }}/>
        </h1>
        
        <div style={styles.badgeContainer}>
          <span style={styles.badgePrimary}>Status: In Development</span>
          <span style={styles.badgeSecondary}>Art: AI-Assisted (Human-Retouched)</span>
        </div>

        {/* UPDATED SUBTITLE */}
        <p style={styles.subtitle}>
          <p>
            When a Demon gives you the power of x-ray vision, you are met with a decision.
          </p>
          <span style={{ fontWeight: 'bold', fontSize: '32px' }}>
            <span style={{color: '#03b6fc' }}>Good</span> or <span style={{color: '#ff007f' }}>evil.</span>
          </span>
          <p style={{ fontWeight: 'bold' }}>
            The choice is yours, but beware of the consequences
          </p>
        </p>

        {/* ACTION BUTTONS */}
        <div style={styles.buttonGroup}>
          <a 
            href="https://foreplaygames.itch.io/3xray"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.primaryButton}
          >
            Follow on Itch.io
          </a>
          <a 
            href="https://x.com/ForeplayGames"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.secondaryButton}
          >
            Follow us on X / Twitter
          </a>
          {/* <a 
            href="https://www.patreon.com/ForeplayGames"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.secondaryButton}
          >
            Get Early Access (Patreon)
          </a> */}
        </div>

        <hr style={{margin: '60px 0', border: 'none' }} />

        {/* FEATURES GRID */}
        <div style={styles.grid}>
          
          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>👁️ X-Ray Vision</h3>
            <p style={styles.text}>
              The X-Ray vision mechanic allows you to 'investigate' any and all characters in the game. Use it to confiscate contraband,
              get a job as TSA security at the local Airport, or simply enjoy the power to see everything!
            </p>
          </div>

          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>⚖️ Karma System</h3>
            <p style={styles.text}>
              Will you use your power to help the girls, or manipulate them for your own gain? Your choices define the route. But remember, all actions have consequences!
            </p>
          </div>

          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>💕 20+ Girls to Choose</h3>
            <p style={styles.text}>
              With over 20 unique characters and a wide variety of personalities, backgrounds and secrets. Multiple endings featuring different characters for high replayability.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}